module.exports = __webpack_public_path__ + "img/1200px-Roundel_of_Italy.svg.644dba64.png";